/**
 * Escapes special characters in a string for use in a regular expression.
 * @param str - The string to escape
 * @returns The escaped string, or an empty string if input is not a string
 */
export function escapeRegExp(str: string) {
  return typeof str === 'string' ? str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') : '';
}
